// ======================================================================
// File Name       : LiveperformanceListContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import moment from 'moment';
import { Field, reduxForm, isInvalid, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { Button, Col } from 'react-bootstrap';
import LivePerformanceDetailInfo from '../../components/livePerformance/LivePerformanceDetailInfo';
import LivePerformanceDetailRelationStatus from '../../components/livePerformance/LivePerformanceDetailRelationStatus';
import * as LivePerformanceAction from '../../actions/LivePerformanceAction';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { VALIDATE_TYPE, RETURN_MAX_NUM, DEFAULT_DATE_FORMAT_SERVER } from '../../constants/index';
import RenderField from '../../utils/ReduxFormUtils';
import Header from '../../components/Header';
import LiveReservedUserAttributeList from '../../components/usageSettingLive/LiveReservedUserAttributeList';
import CustomLink from '../../components/button/CustomLink';
import * as Path from '../../constants/PathConstants';

class LivePerformanceDetailContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterData: {
        contentSortType: null,
        ascendingDescendingSort: null,
        startPosition: 0,
        userSecernId: '',
        liveStartFrom: null,
        liveStartTo: null,
        returnMaxNum: RETURN_MAX_NUM,
        userAttributeKeyNum: 0,
        userAttributeSearchText: '',
        liveName: '',
      },
      recordNum: 0,
      liveList: [],
      livePerformanceObj: {},
    };
    this.onSearchData = this.onSearchData.bind(this);
    this.getDetailOfLivePerformance = this.getDetailOfLivePerformance.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.createParams = this.createParams.bind(this);
    this.goBack = this.goBack.bind(this);
  }

  componentWillMount() {
    const { match } = this.props;
    this.onSearchData(match.params.id);
  }

  // #7129 START
  componentWillUnmount() {
    this.props.dispatch(LivePerformanceAction.resetLivePerformanceDetail());
  }
  // #7129 END

    /**
     *       Search Data
    */
  onSearchData(liveId) {
    this.getDetailOfLivePerformance(liveId);
  }

  /**
   * Paging
   */
  getStartEndData(startPosition) {
    const { match } = this.props;
    const liveId = match.params.id;
    const paramSearch = this.createParams(false, true, liveId, startPosition);
    this.props.dispatch(LivePerformanceAction.getLivePerformanceDetailPaging(paramSearch));
  }

    /**
     * Search button
     */
  getDetailOfLivePerformance(liveId) {
    const paramSearch = this.createParams(false, true, liveId, 0);
    this.props.dispatch(LivePerformanceAction.getLivePerformanceDetail(paramSearch));
  }
  goBack() {
    this.props.history.goBack();
  }

  createParams(isCSV, isSelectTargetData, liveId, startPosition) {
    const filterData = {
      liveList: [liveId],
      startPosition,
      returnMaxNum: RETURN_MAX_NUM,
    };
    let selectTargetData = 0;
    if (isCSV) {
      selectTargetData = 1;
    }
    let param = {};
    if (isSelectTargetData) {
      param = {
        selectTargetData,
        searchInfo: filterData,
      };
    } else {
      param = {
        searchInfo: filterData,
      };
    }

    return param;
  }

  render() {
    const {
      liveList,
      recordNumRelation,
      liveReserveDetail,
      userAttributeList,
    } = this.props;
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.USER_HISTORY_LIVE_PERFORMANCE_LIST}
          text="ライブ別実績に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="ライブ別履歴情報の詳細" />
        <LivePerformanceDetailInfo
          {...liveReserveDetail}
        />
        <LiveReservedUserAttributeList
          userAttributeList={userAttributeList} 
        />
        <LivePerformanceDetailRelationStatus
          liveDetailObj={liveList}
          recordNum={recordNumRelation}
          getStartEndData={this.getStartEndData}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {
    liveList,
    recordNumRelation,
    liveReserveDetail,
    userAttributeList,
  } = state.userHistoryLivePerformance;
  const { initialData } = state.userHistoryLivePerformance;
  const { livePerformanceList } = state.form;
  const filterData = getFormValues('livePerformanceDetail')(state);
  const invalid = isInvalid('livePerformanceDetail')(state);
  return {
    ...{ liveList },
    ...{ liveReserveDetail },
    ...{ userAttributeList },
    filterData,
    initialValues: initialData,
    recordNumRelation,
    invalid,
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'livePerformanceDetail', // a unique identifier for this form
  touchOnChange: true,
})(LivePerformanceDetailContainer));
